import { type ReactNode } from "react";
import { IconButton } from "@mui/material";
import { keyframes } from "@mui/material/styles";
import { customPalette } from "../theme/palette";

const spinnerRotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

type RecorderActionButtonProps = {
  disabled?: boolean;
  isBusy?: boolean;
  isRecording?: boolean;
  hasSavedAttempt?: boolean;
  onClick: () => void;
  children: ReactNode;
};

export function RecorderActionButton({
  disabled = false,
  isBusy = false,
  isRecording = false,
  hasSavedAttempt = false,
  onClick,
  children,
}: RecorderActionButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={(theme) => ({
        position: "relative",
        width: 80,
        height: 80,
        border: "2px solid",
        borderColor: isRecording
          ? customPalette.gray["400"]
          : theme.palette.primary.dark,
        backgroundColor: isRecording
          ? customPalette.gray["300"]
          : theme.palette.primary.dark,
        "&:hover": {
          backgroundColor:
            disabled || hasSavedAttempt
              ? undefined
              : isRecording
                ? customPalette.gray["300"]
                : theme.palette.primary.main,
          borderColor:
            disabled || hasSavedAttempt
              ? undefined
              : isRecording
                ? customPalette.gray["400"]
                : theme.palette.primary.main,
        },
        "&.Mui-disabled": {
          borderColor: hasSavedAttempt
            ? theme.palette.primary.dark
            : theme.palette.action.disabled,
          backgroundColor: hasSavedAttempt
            ? theme.palette.primary.dark
            : theme.palette.action.disabledBackground,
          opacity: hasSavedAttempt ? 0.55 : 1,
        },
        ...(isBusy
          ? {
              "&::before": {
                content: '""',
                position: "absolute",
                inset: -6,
                borderRadius: "50%",
                border: "3px solid transparent",
                borderTopColor: theme.palette.primary.main,
                borderRightColor: theme.palette.primary.main,
                animation: `${spinnerRotation} 0.9s linear infinite`,
              },
            }
          : {}),
      })}
    >
      {children}
    </IconButton>
  );
}
